import { InternalPurchaserSchema } from '@buyerflo/core/schemas/purchaser'
import { Dispatch, SetStateAction, createContext, useContext } from 'react'

export const PurchaserContext = createContext<{
    purchaser: InternalPurchaserSchema
    setPurchaser: Dispatch<SetStateAction<InternalPurchaserSchema>>
    refreshPurchaser: () => Promise<void>
}>(undefined as any)
export const usePurchaserContext = () => useContext(PurchaserContext)
